import { Animated, Text } from 'react-native';
import { useTutorialEntrance } from '../../src/tutorial/hooks/useTutorialEntrance';
import { ONBOARDING_COLORS } from '../../src/tutorial/constants/onboardingContent.constants';
import { onboardingHeadlineStyles as styles } from './OnboardingHeadline.styles';

interface OnboardingHeadlineProps {
  isActive: boolean;
  title: string;
  subtitle?: string;
  /** Substring of `title` rendered in the accent color (e.g. "head-to-head."). */
  highlight?: string;
  highlightColor?: string;
  /** How the subtitle reads: a small muted line, or a big colored second headline line. */
  subtitleVariant?: 'muted' | 'accentLine';
  subtitleColor?: string;
  delayMs?: number;
}

/** Renders a title (with optional colored substring) + subtitle, with the shared entrance. */
export function OnboardingHeadline({
  isActive,
  title,
  subtitle,
  highlight,
  highlightColor = ONBOARDING_COLORS.gold,
  subtitleVariant = 'muted',
  subtitleColor = ONBOARDING_COLORS.mint,
  delayMs = 40,
}: OnboardingHeadlineProps) {
  const { opacity, scale } = useTutorialEntrance(isActive, delayMs);

  const titleNode =
    highlight && title.includes(highlight)
      ? (() => {
          const [before, after] = title.split(highlight);
          return (
            <Text style={styles.title}>
              {before}
              <Text style={{ color: highlightColor }}>{highlight}</Text>
              {after}
            </Text>
          );
        })()
      : <Text style={styles.title}>{title}</Text>;

  return (
    <Animated.View style={[styles.wrap, { opacity, transform: [{ scale }] }]}>
      {titleNode}
      {subtitle ? (
        subtitleVariant === 'accentLine' ? (
          <Text style={[styles.subAccentLine, { color: subtitleColor }]}>{subtitle}</Text>
        ) : (
          <Text style={styles.subMuted}>{subtitle}</Text>
        )
      ) : null}
    </Animated.View>
  );
}
